module.exports = __webpack_public_path__ + "images/marketing/features/activity-report.png";